import { projectEmitCertificationConfirm } from "../api/projectEmitCertificationConfirm";
export const saveProjectEmitCertificationConfirm = data => {
  return projectEmitCertificationConfirm.save(data).then(response => response);
};
